import React, { useState, useCallback, useMemo } from "react";
import btnStyle from "../../../../utils/buttonStyle.json";
import { useTranslation } from "react-i18next";
import { IoIosArrowRoundBack } from "react-icons/io";
import { getCustomerEmail } from "../../../../utils/getCustomerEmail";

type EmailProps = {
    question: {
        helpText: string;
        type: string;
        _id: string;
        imgUrl: string;
        questionText: string;
        answers: {
            _id: string;
            label: string;
            answerText: string
        }[];
        cta: {
            _id: string;
            ctaText: string;
            ctaType: string;
            linkedQuestionId: string;
        }[];
    };
    handleBackBtn: () => void;
    updateUserResponse: (response: {
        questionType: string;
        questionText: string;
        nextQuestionId: string;
        _id: string;
        action?: string;
        answerResponse: Array<object>;
        selfieResponse: Array<object>;
        selfieID: string;
        userSelfie: string;
        timeStamp: number;
        backBtnConfig: object;
    }) => void;
};

const Email: React.FC<EmailProps> = ({ question, updateUserResponse, handleBackBtn, inputs, backBtnConfig }) => {
    const { t } = useTranslation()
    const customerEmail = getCustomerEmail();
    const [email, setEmail] = useState({
        _id: question.answers[0]?._id,
        inputType: "email",
        inputValue: customerEmail,
        tag: question.answers[0]?.tag || "",
        inputLabel: question.answers[0]?.label || "",
        inputRequired: question.answers[0]?.required !== undefined ? question.answers[0].required : true,
    });
    const [error, setError] = useState('');

    const emailRegex = useMemo(() => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, []);

    const handleEmailInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const newEmail = { ...email, inputValue: e.target.value };
        setEmail(newEmail);
    }, [email]);

    const constructResponse = useCallback((cta: { _id: string; ctaText: string; ctaType: string; linkedQuestionId: string; }, skip = false) => {
        return {
            questionType: question.type,
            questionText: question.questionText,
            nextQuestionId: cta?.linkedQuestionId || '',
            _id: question._id,
            action: cta.ctaType,
            answerResponse: skip ? [] : [email],
            selfieResponse: [],
            selfieID: '',
            userSelfie: '',
            timeStamp: new Date().getTime()
        };
    }, [question, email]);

    const handleSubmitBtn = useCallback((cta: { _id: string; ctaText: string; ctaType: string; linkedQuestionId: string; }) => {
        if (!email.inputValue.trim()) {
            setError(t("enterEmail"));
            return;
        }
        if (!emailRegex.test(email.inputValue)) {
            setError(t("enterValidEmail"));
            return;
        }
        setError('');
        updateUserResponse(constructResponse(cta));
    }, [email, emailRegex, constructResponse, updateUserResponse]);

    return (
        <>
            <button className="tangent_backbtn_custom tangent_backbtn_mob_custom tngnt-absolute tngnt-top-0 tngnt-self-start tngnt-m-4 tngnt-text-[30px]" onClick={handleBackBtn}>
                {backBtnConfig ? <img src={backBtnConfig.backBtn_icon} alt="back button" /> : <IoIosArrowRoundBack color="#929292" size={"3rem"} />}
            </button>
            <div className={"tangent_form_screen_custom tangent_form_screen_mob_custom tngnt-flex tngnt-flex-col tngnt-items-center tngnt-gap-4 sm:tngnt-gap-6 tngnt-p-3 tngnt-pt-16 sm:tngnt-p-6 sm:tngnt-pt-16 tngnt-justify-center tngnt-w-[100%]"} id={`comp_${question._id}`}>
                <div className="tangent_global_style tangent_question_text tangent_form_text_custom tngnt-text-center tngnt-text-[20px] tngnt-ml-[15px] tngnt-mr-[15px] tngnt-w-[90%]" dangerouslySetInnerHTML={{ __html: eval('`' + question.questionText + '`') }} />
                {question.imgUrl ? (
                    <img className="tangent_form_image_custom tangent_form_image_mob_custom tngnt-max-w-[inherit] tngnt-w-[100%] tngnt-max-h-[300px] tngnt-object-contain" src={question.imgUrl} alt="question image" />
                ) : null}
                <div className="tngnt-flex tngnt-flex-col tngnt-w-[100%] sm:tngnt-w-[80%] tngnt-gap-5 tngnt-items-center tngnt-my-6">
                    <div className="tngnt-flex tngnt-flex-col tngnt-w-[90%] sm:tngnt-w-[100%]">
                        <label className="tangent_input_label_style_custom tngnt-text-sm tngnt-pb-1">{question.answers[0]?.label}</label>
                        <input
                            className="tangent_global_style tangent_global_style_custom tangent_form_input_custom tangent_form_input_mob_custom tngnt-border-solid tngnt-border tngnt-border-black tngnt-leading-[24px] tngnt-text-[16px] tngnt-px-[8px] tngnt-py-[8px]"
                            type="email"
                            placeholder={question.answers[0]?.answerText}
                            onChange={handleEmailInput}
                            value={email.inputValue || ''}
                        />
                        <span className="tangent_input_error_style_custom tngnt-text-base tngnt-mt-2 tngnt-text-red-600">{error}</span>
                    </div>
                </div>
                {question.cta.map((cta) => (
                    <button
                        key={cta._id}
                        className={(cta.ctaType === "skip" ? "tangent_form_skip_button_custom tangent_form_skip_button_mob_custom " : "tangent_form_submit_button_custom tangent_form_submit_button_mob_custom ") + 'tangent_global_style tangent_global_style_custom tngnt-p-2 tngnt-w-[90%] sm:tngnt-w-[50%] tngnt-text-[16px] ' + btnStyle[cta.ctaType]}
                        onClick={cta.ctaType === "submit" ? () => handleSubmitBtn(cta) : () => updateUserResponse(constructResponse(cta, true))}
                    >
                        {cta.ctaText}
                    </button>
                ))}
                {
                    question?.helpText && <div className="tangent_global_style tangent_global_style_custom tangent_helpText_custom tngnt-text-center tngnt-p-2 tngnt-mt-6 tngnt-text-[14px] tngnt-leading-[20px]" dangerouslySetInnerHTML={{ __html: eval('`' + question.helpText + '`') }}></div>
                }
            </div >
        </>
    );
};

export default Email;